<template>
    <label class="block font-medium text-sm text-gray-700">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot></slot></span>
        <span v-if="tooltip" class='has-tooltip ml-1'>
        <font-awesome-icon icon="fa-question-circle" />
        <span class='tooltip rounded shadow-lg p-2 bg-rent-risk-blue-100 border text-grey-500 -mt-8 w-1/3' v-html="tooltip"></span>
    </span>
    </label>
</template>

<script>
    export default {
        props: ['value','tooltip']
    }
</script>
